// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mOI7","controls":"styles_controls__2dx4S","charLimit":"styles_charLimit__h21_c","input":"styles_input__3u7QA","send":"styles_send__2-NAa"};